import React from 'react';
import TopBar from 'src/layouts/TopBar';
import Footer from 'src/layouts/Footer';
import NavBar from './NavBar';

const ProfileLayout = ({ children }) => {
  return (
    <div>
      <TopBar />
      <div className="main">
        <nav
          id="local-navigation"
          className="navigation-bar service-navigation-bar"
        >
          <NavBar />
        </nav>
        <div className="child-content">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfileLayout;
